import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useFileUploadState, FormItem, FormLabel, FormInputFilesList, FormInputFileUpload } from '@tesla/design-system-react';
import { useField } from 'informed';
import { FeedBack } from './Feedback.js';

var _excluded = ["onChange"],
  _excluded2 = ["label", "feedback", "helper", "caption", "tooltip", "title", "multiple", "onRemove"],
  _excluded3 = ["id", "disabled", "readonly"];
var Error = function Error(_ref) {
  var error = _ref.error;
  if (typeof error === 'string') {
    return error;
  }
  var _ref2 = error !== null && error !== void 0 ? error : {},
    maxFileSizeExceeded = _ref2.maxFileSizeExceeded,
    maxFilesExceeded = _ref2.maxFilesExceeded;
    _ref2.required;
  if (maxFileSizeExceeded) {
    return "Max file size exceeded for ".concat(maxFileSizeExceeded.join(', '));
  }
  if (maxFilesExceeded) {
    return "Max number of files exceeded, ".concat(maxFilesExceeded.join(', '));
  }
  return null;
};
var FileUpload = /*#__PURE__*/React.memo(function (_ref3) {
  var _value$fileNames;
  var _onChange = _ref3.onChange,
    props = _objectWithoutProperties(_ref3, _excluded);
  var _useField = useField(_objectSpread2({}, props)),
    fieldState = _useField.fieldState,
    fieldApi = _useField.fieldApi,
    render = _useField.render,
    userProps = _useField.userProps;
  var setValue = fieldApi.setValue,
    setTouched = fieldApi.setTouched,
    setFocused = fieldApi.setFocused,
    setError = fieldApi.setError;
  var onSetFileList = function onSetFileList(_ref4) {
    var files = _ref4.files,
      fileNames = _ref4.fileNames,
      fileSelectErrors = _ref4.fileSelectErrors;
    if (fileNames.length > 0) {
      setValue({
        fileNames: fileNames,
        files: files
      });
    } else {
      setValue(undefined);
    }
    if (fileSelectErrors != null) {
      setError(fileSelectErrors);
    } else {
      setError(undefined);
    }
  };
  var _useFileUploadState = useFileUploadState({
      onSetFileList: onSetFileList
    }),
    handleInputChange = _useFileUploadState.handleInputChange,
    handleItemRemove = _useFileUploadState.handleItemRemove,
    inputRef = _useFileUploadState.inputRef;
  var label = userProps.label,
    feedback = userProps.feedback,
    helper = userProps.helper,
    caption = userProps.caption,
    tooltip = userProps.tooltip,
    title = userProps.title,
    multiple = userProps.multiple,
    _onRemove = userProps.onRemove,
    inputProps = _objectWithoutProperties(userProps, _excluded2);
  var id = inputProps.id,
    disabled = inputProps.disabled,
    readonly = inputProps.readonly,
    restInputProps = _objectWithoutProperties(inputProps, _excluded3);
  var showError = fieldState.showError,
    error = fieldState.error,
    value = fieldState.value;
  var fileNames = (_value$fileNames = value === null || value === void 0 ? void 0 : value.fileNames) !== null && _value$fileNames !== void 0 ? _value$fileNames : [];
  return render( /*#__PURE__*/React.createElement(FormItem, {
    error: showError,
    variant: "file-upload",
    disabled: disabled,
    readOnly: readonly
  }, title ? /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: id,
    caption: caption,
    tooltip: tooltip
  }, title) : null, /*#__PURE__*/React.createElement(FormInputFilesList, {
    fileNames: fileNames,
    onRemove: function onRemove(e) {
      handleItemRemove(e);
      if (_onRemove) {
        _onRemove(e);
      }
    }
  }), /*#__PURE__*/React.createElement(FormInputFileUpload, _extends({}, restInputProps, {
    type: "file",
    id: id,
    inputRef: inputRef,
    label: label,
    multiple: multiple,
    onChange: function onChange(e) {
      handleInputChange(e);
      if (_onChange) {
        _onChange(e);
      }
    },
    onBlur: function onBlur(e) {
      setTouched(true, e);
    },
    onFocus: function onFocus(e) {
      setFocused(true, e);
    }
  })), /*#__PURE__*/React.createElement(FeedBack, {
    feedback: feedback,
    helper: helper,
    error: /*#__PURE__*/React.createElement(Error, {
      error: error
    }),
    showError: showError,
    id: "".concat(id, "-feedback")
  })));
});

export { FileUpload };
